exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#error-layout{max-width:80%;margin:0 auto;padding:120px 0;text-align:center}#error-layout h1{font-size:150px;margin:0 0 .5em;padding:0}#error-layout .message{font-size:1.6em}@media (max-width:767px){#error-layout h1{font-size:50px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-96454bee","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./src/layouts/error/style.scss
// module id = 888
// module chunks = 0